const Spinner = {
   show() {
      document.getElementById("global-spinner")?.classList.remove("hidden");
   },
   hide() {
      document.getElementById("global-spinner")?.classList.add("hidden");
   },
};

function getFocusableElements(container) {
   return Array.from(
      container.querySelectorAll(
         "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
   );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
   summary.setAttribute("role", "button");
   summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
   );

   if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
   }

   summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
         "aria-expanded",
         !event.currentTarget.closest("details").hasAttribute("open")
      );
   });

   if (summary.closest("header-drawer")) return;
   summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
   var elements = getFocusableElements(container);
   var first = elements[0];
   var last = elements[elements.length - 1];

   removeTrapFocus();

   trapFocusHandlers.focusin = (event) => {
      if (
         event.target !== container &&
         event.target !== last &&
         event.target !== first
      )
         return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
   };

   trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
   };

   trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
         event.preventDefault();
         first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
         (event.target === container || event.target === first) &&
         event.shiftKey
      ) {
         event.preventDefault();
         last.focus();
      }
   };

   document.addEventListener("focusout", trapFocusHandlers.focusout);
   document.addEventListener("focusin", trapFocusHandlers.focusin);

   elementToFocus.focus();

   if (
      elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
   ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
   }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
   document.querySelector(":focus-visible");
} catch (e) {
   focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
   const navKeys = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
   ];
   let currentFocusedElement = null;
   let mouseClick = null;

   window.addEventListener("keydown", (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
         mouseClick = false;
      }
   });

   window.addEventListener("mousedown", (event) => {
      mouseClick = true;
   });

   window.addEventListener(
      "focus",
      () => {
         if (currentFocusedElement)
            currentFocusedElement.classList.remove("focused");

         if (mouseClick) return;

         currentFocusedElement = document.activeElement;
         currentFocusedElement.classList.add("focused");
      },
      true
   );
}

function pauseAllMedia() {
   document.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
         '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
         "*"
      );
   });
   document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
   });
   document.querySelectorAll("video").forEach((video) => video.pause());
   document.querySelectorAll("product-model").forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
   });
}

function removeTrapFocus(elementToFocus = null) {
   document.removeEventListener("focusin", trapFocusHandlers.focusin);
   document.removeEventListener("focusout", trapFocusHandlers.focusout);
   document.removeEventListener("keydown", trapFocusHandlers.keydown);

   if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
   if (event.code.toUpperCase() !== "ESCAPE") return;

   const openDetailsElement = event.target.closest("details[open]");
   if (!openDetailsElement) return;

   const summaryElement = openDetailsElement.querySelector("summary");
   openDetailsElement.removeAttribute("open");
   summaryElement.setAttribute("aria-expanded", false);
   summaryElement.focus();
}

class QuantityInput extends HTMLElement {
   constructor() {
      super();
      this.input = this.querySelector("input");
      this.changeEvent = new Event("change", {
         bubbles: true
      });

      this.querySelectorAll("button").forEach((button) =>
         button.addEventListener("click", this.onButtonClick.bind(this))
      );
   }

   onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value)
         this.input.dispatchEvent(this.changeEvent);
   }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
   let t;
   return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
   };
}

function fetchConfig(type = "json") {
   return {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
         Accept: `application/${type}`,
      },
   };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
   window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
   return function () {
      return fn.apply(scope, arguments);
   };
};

Shopify.setSelectorByValue = function (selector, value) {
   for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
         selector.selectedIndex = i;
         return i;
      }
   }
};

Shopify.addListener = function (target, eventName, callback) {
   target.addEventListener ?
      target.addEventListener(eventName, callback, false) :
      target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
   options = options || {};
   var method = options["method"] || "post";
   var params = options["parameters"] || {};

   var form = document.createElement("form");
   form.setAttribute("method", method);
   form.setAttribute("action", path);

   for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
   }
   document.body.appendChild(form);
   form.submit();
   document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
   country_domid,
   province_domid,
   options
) {
   this.countryEl = document.getElementById(country_domid);
   this.provinceEl = document.getElementById(province_domid);
   this.provinceContainer = document.getElementById(
      options["hideElement"] || province_domid
   );

   Shopify.addListener(
      this.countryEl,
      "change",
      Shopify.bind(this.countryHandler, this)
   );

   this.initCountry();
   this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
   initCountry: function () {
      var value = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
   },

   initProvince: function () {
      var value = this.provinceEl.getAttribute("data-default");
      if (value && this.provinceEl.options.length > 0) {
         Shopify.setSelectorByValue(this.provinceEl, value);
      }
   },

   countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      var raw = opt.getAttribute("data-provinces");
      var provinces = JSON.parse(raw);

      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
         this.provinceContainer.style.display = "none";
      } else {
         for (var i = 0; i < provinces.length; i++) {
            var opt = document.createElement("option");
            opt.value = provinces[i][0];
            opt.innerHTML = provinces[i][1];
            this.provinceEl.appendChild(opt);
         }

         this.provinceContainer.style.display = "";
      }
   },

   clearOptions: function (selector) {
      while (selector.firstChild) {
         selector.removeChild(selector.firstChild);
      }
   },

   setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
         var opt = document.createElement("option");
         opt.value = values[i];
         opt.innerHTML = values[i];
         selector.appendChild(opt);
      }
   },
};

class MenuDrawer extends HTMLElement {
   constructor() {
      super();

      this.mainDetailsToggle = this.querySelector("details");

      this.addEventListener("keyup", this.onKeyUp.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.bindEvents();
   }

   bindEvents() {
      this.querySelectorAll("summary").forEach((summary) =>
         summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
      this.querySelectorAll("button").forEach((button) =>
         button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
   }

   onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle ?
         this.closeMenuDrawer(
            event,
            this.mainDetailsToggle.querySelector("summary")
         ) :
         this.closeSubmenu(openDetailsElement);
   }

   onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".has-submenu");
      const isOpen = detailsElement.hasAttribute("open");
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      function addTrapFocus() {
         trapFocus(
            summaryElement.nextElementSibling,
            detailsElement.querySelector("button")
         );
         summaryElement.nextElementSibling.removeEventListener(
            "transitionend",
            addTrapFocus
         );
      }

      if (detailsElement === this.mainDetailsToggle) {
         if (isOpen) event.preventDefault();
         isOpen
            ?
            this.closeMenuDrawer(event, summaryElement) :
            this.openMenuDrawer(summaryElement);

         if (window.matchMedia("(max-width: 990px)")) {
            document.documentElement.style.setProperty(
               "--viewport-height",
               `${window.innerHeight}px`
            );
         }
      } else {
         setTimeout(() => {
            detailsElement.classList.add("menu-opening");
            summaryElement.setAttribute("aria-expanded", true);
            parentMenuElement && parentMenuElement.classList.add("submenu-open");
            !reducedMotion || reducedMotion.matches ?
               addTrapFocus() :
               summaryElement.nextElementSibling.addEventListener(
                  "transitionend",
                  addTrapFocus
               );
         }, 100);
      }
   }

   openMenuDrawer(summaryElement) {
      setTimeout(() => {
         this.mainDetailsToggle.classList.add("menu-opening");
      });
      summaryElement.setAttribute("aria-expanded", true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
   }

   closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;

      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
         details.removeAttribute("open");
         details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
         .querySelectorAll(".submenu-open")
         .forEach((submenu) => {
            submenu.classList.remove("submenu-open");
         });
      document.body.classList.remove(
         `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
   }

   onFocusOut(event) {
      setTimeout(() => {
         if (
            this.mainDetailsToggle.hasAttribute("open") &&
            !this.mainDetailsToggle.contains(document.activeElement)
         )
            this.closeMenuDrawer();
      });
   }

   onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
   }

   closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest(".submenu-open");
      parentMenuElement && parentMenuElement.classList.remove("submenu-open");
      detailsElement.classList.remove("menu-opening");
      detailsElement
         .querySelector("summary")
         .setAttribute("aria-expanded", false);
      removeTrapFocus(detailsElement.querySelector("summary"));
      this.closeAnimation(detailsElement);
   }

   closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
         if (animationStart === undefined) {
            animationStart = time;
         }

         const elapsedTime = time - animationStart;

         if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
         } else {
            detailsElement.removeAttribute("open");
            if (detailsElement.closest("details[open]")) {
               trapFocus(
                  detailsElement.closest("details[open]"),
                  detailsElement.querySelector("summary")
               );
            }
         }
      };

      window.requestAnimationFrame(handleAnimation);
   }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
   constructor() {
      super();
   }

   openMenuDrawer(summaryElement) {
      this.header =
         this.header || document.getElementById("shopify-section-header");
      this.borderOffset =
         this.borderOffset ||
         this.closest(".header-wrapper").classList.contains(
            "header-wrapper--border-bottom"
         ) ?
         1 :
         0;
      document.documentElement.style.setProperty(
         "--header-bottom-position",
         `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
      );
      this.header.classList.add("menu-open");

      setTimeout(() => {
         this.mainDetailsToggle.classList.add("menu-opening");
      });

      summaryElement.setAttribute("aria-expanded", true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
   }

   closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove("menu-open");
   }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
   constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
         "click",
         this.hide.bind(this, false)
      );
      this.addEventListener("keyup", (event) => {
         if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
      if (this.classList.contains("media-modal")) {
         this.addEventListener("pointerup", (event) => {
            if (
               event.pointerType === "mouse" &&
               !event.target.closest("deferred-media, product-model")
            )
               this.hide();
         });
      } else {
         this.addEventListener("click", (event) => {
            if (event.target === this) this.hide();
         });
      }
   }

   connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
   }

   show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
   }

   hide() {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
   }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
   constructor() {
      super();

      const button = this.querySelector("button");

      if (!button) return;
      button.addEventListener("click", () => {
         const modal = document.querySelector(this.getAttribute("data-modal"));
         if (modal) modal.show(button);
      });
   }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
   constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener("click", this.loadContent.bind(this));
   }

   loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute("loaded")) {
         const content = document.createElement("div");
         content.appendChild(
            this.querySelector("template").content.firstElementChild.cloneNode(true)
         );

         this.setAttribute("loaded", true);
         const deferredElement = this.appendChild(
            content.querySelector("video, model-viewer, iframe")
         );
         if (focus) deferredElement.focus();
      }
   }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
   constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector(".slider-counter--current");
      this.pageTotalElement = this.querySelector(".slider-counter--total");
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener("scroll", this.update.bind(this));
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
   }

   initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
         (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
         this.sliderItemsToShow[1].offsetLeft -
         this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
         (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
         this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
   }

   resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
   }

   update() {
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage =
         Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
         this.currentPageElement.textContent = this.currentPage;
         this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage != previousPage) {
         this.dispatchEvent(
            new CustomEvent("slideChanged", {
               detail: {
                  currentPage: this.currentPage,
                  currentElement: this.sliderItemsToShow[this.currentPage - 1],
               },
            })
         );
      }

      if (this.enableSliderLooping) return;

      if (
         this.isSlideVisible(this.sliderItemsToShow[0]) &&
         this.slider.scrollLeft === 0
      ) {
         this.prevButton.setAttribute("disabled", "disabled");
      } else {
         this.prevButton.removeAttribute("disabled");
      }

      if (
         this.isSlideVisible(
            this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
         )
      ) {
         this.nextButton.setAttribute("disabled", "disabled");
      } else {
         this.nextButton.removeAttribute("disabled");
      }
   }

   isSlideVisible(element, offset = 0) {
      const lastVisibleSlide =
         this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
         element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
         element.offsetLeft >= this.slider.scrollLeft
      );
   }

   onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
         event.currentTarget.name === "next" ?
         this.slider.scrollLeft + step * this.sliderItemOffset :
         this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
         left: this.slideScrollPosition,
      });
   }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
   constructor() {
      super();
      this.sliderControlWrapper = this.querySelector(".slider-buttons");
      this.enableSliderLooping = true;

      if (!this.sliderControlWrapper) return;

      this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

      this.sliderControlLinksArray = Array.from(
         this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
      );
      this.sliderControlLinksArray.forEach((link) =>
         link.addEventListener("click", this.linkToSlide.bind(this))
      );
      this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      if (this.slider.getAttribute("data-autoplay") === "true")
         this.setAutoPlay();
   }

   setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.autoplaySpeed = this.slider.dataset.speed * 1000;

      this.sliderAutoplayButton.addEventListener(
         "click",
         this.autoPlayToggle.bind(this)
      );
      this.addEventListener("mouseover", this.focusInHandling.bind(this));
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
      this.addEventListener("focusin", this.focusInHandling.bind(this));
      this.addEventListener("focusout", this.focusOutHandling.bind(this));

      this.play();
      this.autoplayButtonIsSetToPlay = true;
   }

   onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

      if (!isFirstSlide && !isLastSlide) return;

      if (isFirstSlide && event.currentTarget.name === "previous") {
         this.slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === "next") {
         this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
         left: this.slideScrollPosition,
      });
   }

   update() {
      super.update();

      // Query slider controls
      this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");

      // Make sure prev button exists before touching it
      if (this.prevButton) {
         this.prevButton.removeAttribute("disabled");
      }

      // If there are no buttons, nothing to update
      if (!this.sliderControlButtons.length) return;

      // Reset all buttons
      this.sliderControlButtons.forEach((link) => {
         link.classList.remove("slider-counter__link--active");
         link.removeAttribute("aria-current");
      });

      // Compute active index
      let activeIndex = this.currentPage - 1;

      // 🔑 Fix: resync if index is out of range
      if (activeIndex < 0) {
         activeIndex = 0;
         this.currentPage = 1;
      }
      if (activeIndex >= this.sliderControlButtons.length) {
         activeIndex = this.sliderControlButtons.length - 1;
         this.currentPage = activeIndex + 1;
      }

      // Apply active state
      const activeButton = this.sliderControlButtons[activeIndex];
      if (activeButton) {
         activeButton.classList.add("slider-counter__link--active");
         activeButton.setAttribute("aria-current", "true");
      }
   }


   autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
   }

   focusOutHandling(event) {
      const focusedOnAutoplayButton =
         event.target === this.sliderAutoplayButton ||
         this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
   }

   focusInHandling(event) {
      const focusedOnAutoplayButton =
         event.target === this.sliderAutoplayButton ||
         this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
         this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
         this.pause();
      }
   }

   play() {
      this.slider.setAttribute("aria-live", "off");
      clearInterval(this.autoplay);
      this.autoplay = setInterval(
         this.autoRotateSlides.bind(this),
         this.autoplaySpeed
      );
   }

   pause() {
      this.slider.setAttribute("aria-live", "polite");
      clearInterval(this.autoplay);
   }

   togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
         this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
         this.sliderAutoplayButton.setAttribute(
            "aria-label",
            window.accessibilityStrings.playSlideshow
         );
      } else {
         this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
         this.sliderAutoplayButton.setAttribute(
            "aria-label",
            window.accessibilityStrings.pauseSlideshow
         );
      }
   }

   autoRotateSlides() {
      const slideScrollPosition =
         this.currentPage === this.sliderItems.length ?
         0 :
         this.slider.scrollLeft +
         this.slider.querySelector(".slideshow__slide").clientWidth;
      this.slider.scrollTo({
         left: slideScrollPosition,
      });
   }

   setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
         const linkElements = item.querySelectorAll("a");
         if (index === this.currentPage - 1) {
            if (linkElements.length)
               linkElements.forEach((button) => {
                  button.removeAttribute("tabindex");
               });
            item.setAttribute("aria-hidden", "false");
            item.classList.add("active");
            item.removeAttribute("tabindex");
         } else {
            if (linkElements.length)
               linkElements.forEach((button) => {
                  button.setAttribute("tabindex", "-1");
               });
            item.setAttribute("aria-hidden", "true");
            item.classList.remove("active");
            item.setAttribute("tabindex", "-1");
         }
      });
   }

   linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition =
         this.slider.scrollLeft +
         this.sliderFirstItemNode.clientWidth *
         (this.sliderControlLinksArray.indexOf(event.currentTarget) +
            1 -
            this.currentPage);
      this.slider.scrollTo({
         left: slideScrollPosition,
      });
   }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
   constructor() {
      super();
      this.addEventListener("change", this.onVariantChange);
   }

   onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
         this.toggleAddButton(true, "", true);
         this.setUnavailable();
      } else {
         this.updateMedia();
         this.updateURL();
         this.updateVariantInput();
         this.renderProductInfo();
         this.updateShareUrl();
      }
   }

   updateOptions() {
      this.options = Array.from(
         this.querySelectorAll("select"),
         (select) => select.value
      );
   }

   updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
         return !variant.options
            .map((option, index) => {
               return this.options[index] === option;
            })
            .includes(false);
      });
   }

   updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(
         `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGalleries.forEach((mediaGallery) =>
         mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            true
         )
      );

      const modalContent = document.querySelector(
         `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(
         `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
   }

   updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState({},
         "",
         `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
   }

   updateShareUrl() {
      const shareButton = document.getElementById(
         `Share-${this.dataset.section}`
      );
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(
         `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
   }

   updateVariantInput() {
      const productForms = document.querySelectorAll(
         `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
         const input = productForm.querySelector('input[name="id"]');
         input.value = this.currentVariant.id;
         input.dispatchEvent(new Event("change", {
            bubbles: true
         }));
      });
   }

   updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
         (variant) => this.querySelector(":checked").value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll(".product-form__input")];
      inputWrappers.forEach((option, index) => {
         if (index === 0) return;
         const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
         ];
         const previousOptionSelected =
            inputWrappers[index - 1].querySelector(":checked").value;
         const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
               (variant) =>
               variant.available &&
               variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
         this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
   }

   setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
         if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.innerText = input.getAttribute("value");
         } else {
            input.innerText = window.variantStrings.unavailable_with_option.replace(
               "[value]",
               input.getAttribute("value")
            );
         }
      });
   }

   updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
         pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
         pickUpAvailability.removeAttribute("available");
         pickUpAvailability.innerHTML = "";
      }
   }

   removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
   }

   renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;

      fetch(
            `${this.dataset.url}?variant=${requestedVariantId}§ion_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
         )
         .then((response) => response.text())
         .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(responseText, "text/html");
            const destination = document.getElementById(
               `price-${this.dataset.section}`
            );
            const source = html.getElementById(
               `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
            );
            const skuSource = html.getElementById(
               `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
            );
            const skuDestination = document.getElementById(
               `Sku-${this.dataset.section}`
            );
            const inventorySource = html.getElementById(
               `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
            );
            const inventoryDestination = document.getElementById(
               `Inventory-${this.dataset.section}`
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
               inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
               skuDestination.innerHTML = skuSource.innerHTML;
               skuDestination.classList.toggle(
                  "visibility-hidden",
                  skuSource.classList.contains("visibility-hidden")
               );
            }

            const price = document.getElementById(`price-${this.dataset.section}`);

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
               inventoryDestination.classList.toggle(
                  "visibility-hidden",
                  inventorySource.innerText === ""
               );

            this.toggleAddButton(
               !this.currentVariant.available,
               window.variantStrings.soldOut
            );
         });
   }

   toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(
         `product-form-${this.dataset.section}`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
         addButton.setAttribute("disabled", "disabled");
         if (text) addButtonText.textContent = text;
      } else {
         addButton.removeAttribute("disabled");
         addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
   }

   setUnavailable() {
      const button = document.getElementById(
         `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(
         `Inventory-${this.dataset.section}`
      );
      const sku = document.getElementById(`Sku-${this.dataset.section}`);

      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
      if (inventory) inventory.classList.add("visibility-hidden");
      if (sku) sku.classList.add("visibility-hidden");
   }

   getVariantData() {
      this.variantData =
         this.variantData ||
         JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
   }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
   constructor() {
      super();
   }

   setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
         if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
         } else {
            input.classList.add("disabled");
         }
      });
   }

   updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
         return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
         ).value;
      });
   }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
   constructor() {
      super();
   }

   connectedCallback() {
      const handleIntersection = (entries, observer) => {
         if (!entries[0].isIntersecting) return;
         observer.unobserve(this);

         fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
               const html = document.createElement("div");
               html.innerHTML = text;
               const recommendations = html.querySelector("product-recommendations");

               if (recommendations && recommendations.innerHTML.trim().length) {
                  this.innerHTML = recommendations.innerHTML;
               }

               if (
                  !this.querySelector("slideshow-component") &&
                  this.classList.contains("complementary-products")
               ) {
                  this.remove();
               }

               if (html.querySelector(".grid__item")) {
                  this.classList.add("product-recommendations--loaded");
               }

               /*For Frequently Bought Together JS*/
               document.querySelectorAll('[data-section-id]').forEach(el => {
                  window.initFBT?.(el.dataset.sectionId);
               });


            })
            .catch((e) => {
               console.error(e);
            });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
         rootMargin: "0px 0px 400px 0px",
      }).observe(this);
   }
}

customElements.define("product-recommendations", ProductRecommendations);

// Get the button:
let mybutton = document.getElementById("GoToTop");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
   scrollFunction();
};

function scrollFunction() {
   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.opacity = "1";
      mybutton.style.right = "30px";
      mybutton.style.bottom = "90px";
      mybutton.style.transform = "translate3d(1%,1%,0)";
   } else {
      mybutton.style.opacity = "0";
      mybutton.style.right = "0px";
      mybutton.style.bottom = "0px";
      mybutton.style.transform = "translate3d(0,1%,0)";
   }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
   document.body.scrollTop = 0; // For Safari
   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

//Popup hover icons - code
document.addEventListener("DOMContentLoaded", () => {
   // Key names for localStorage
   const WISHLIST_KEY = "shopify-wishlist";
   const COMPARE_KEY = "shopify-compare";

   // Utility functions
   const getList = (key) => JSON.parse(localStorage.getItem(key)) || [];
   const saveList = (key, list) =>
      localStorage.setItem(key, JSON.stringify(list));

   const toggleItem = (key, handle) => {
      const list = getList(key);
      const index = list.indexOf(handle);
      if (index > -1) {
         list.splice(index, 1); // remove
      } else {
         list.push(handle); // add
      }
      saveList(key, list);
      return list;
   };

   const updateButtonState = (button, key) => {
      const list = getList(key);
      const handle = button.dataset.productHandle;
      if (!handle) return;
      if (list.includes(handle)) {
         button.classList.add("active");
      } else {
         button.classList.remove("active");
      }
   };

   // Initialize buttons
   const wishlistButtons = document.querySelectorAll('[data-action="wishlist"]');
   const compareButtons = document.querySelectorAll('[data-action="compare"]');

   wishlistButtons.forEach((btn) => updateButtonState(btn, WISHLIST_KEY));
   compareButtons.forEach((btn) => updateButtonState(btn, COMPARE_KEY));

   // Use event delegation
   document.addEventListener("click", (e) => {
      const icon = e.target.closest(".product-card__hover-icon");
      if (!icon) return;

      const action = icon.dataset.action;
      const productId = icon.dataset.productId;
      const productHandle = icon.dataset.productHandle;
      const handle = icon.dataset.productHandle;
      const formId = icon.dataset.formId;

      Spinner?.show?.();

      if (action === "wishlist") {
         const list = toggleItem(WISHLIST_KEY, handle);
         updateButtonState(icon, WISHLIST_KEY);
         Spinner?.hide?.();
      }

      if (action === "compare") {
         const list = toggleItem(COMPARE_KEY, handle);
         updateButtonState(icon, COMPARE_KEY);
         Spinner?.hide?.();
      } else if (action === "quick-add") {
         const form = document.querySelector(`#${formId}`);

         const formData = new FormData(form);

         fetch("/cart/add.js", {
               method: "POST",
               headers: {
                  Accept: "application/json",
               },
               body: formData,
            })
            .then((res) => {
               if (!res.ok) throw new Error("Add to cart failed");
               Spinner?.hide?.();
               return res.json();
            })

            .then(() => {
               // Fetch updated cart bubble section
               return fetch(`/cart?section_id=cart-icon-bubble`);
            })
            .then((res) => res.text())
            .then((html) => {
               const parser = new DOMParser();
               const doc = parser.parseFromString(html, "text/html");
               const updatedBubble = doc.querySelector(".shopify-section");

               if (updatedBubble) {
                  const target = document.querySelector(
                     "#cart-icon-bubble .shopify-section"
                  );
                  if (target) {
                     target.innerHTML = updatedBubble.innerHTML;
                  } else {
                     const fallback = document.getElementById("cart-icon-bubble");
                     if (fallback) fallback.innerHTML = updatedBubble.innerHTML;
                  }
               }

               if (typeof reInitCartDrawer === "function") reInitCartDrawer();

               // 🔓 Open the Dawn theme cart drawer
               const cartDrawer = document.querySelector("cart-drawer");
               if (cartDrawer && typeof cartDrawer.open === "function") {
                  cartDrawer.classList.remove("is-empty");
                  cartDrawer.open(); // ✅ This is the correct way in Dawn theme
               } else {
                  console.warn("Cart drawer not found or open method unavailable.");
               }

               Spinner?.hide?.();
            })
            .then(() => reInitCartDrawer())
            .catch((err) => console.error("Error:", err))
            .finally(() => {
               //submitButton.disabled = false;
               //submitButton.classList.remove("loading");
            });
      } else if (action === "quick-view") {
         fetch(`/products/${productHandle}?view=quick-view-modal`)
            .then((res) => res.text())
            .then((html) => {
               Spinner?.hide?.();

               const parser = new DOMParser();
               const doc = parser.parseFromString(html, "text/html");
               const productDiv = doc.querySelector("product-info");

               const modal = document.getElementById("quick-view-modal");
               const modalContent = modal.querySelector(
                  ".quick-view-modal__content"
               );

               if (productDiv) {
                  modalContent.innerHTML = "";

                  // Add close button
                  const closeButton = document.createElement("button");
                  closeButton.className = "quick-view-modal__close";
                  closeButton.setAttribute("aria-label", "Close Modal");
                  closeButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
          <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/>
        </svg>
      `; // your SVG
                  closeButton.addEventListener("click", () => {
                     modal.classList.remove("active");
                  });

                  modalContent.appendChild(closeButton);
                  modalContent.appendChild(productDiv);

                  // ✅ Upgrade <product-info>
                  const productInfoElement =
                     modalContent.querySelector("product-info");
                  if (productInfoElement) {
                     customElements.upgrade(productInfoElement);
                  }

                  // ✅ Inject only variant JSON (if needed)

                  const variantScript = doc.querySelector(
                     "script[data-product-json]"
                  );

                  if (variantScript) {
                     try {
                        const productData = JSON.parse(variantScript.textContent);
                        window.VariantData = productData.variants;
                     } catch (e) {
                        console.warn("Invalid VariantData", e);
                     }
                  }

                  // ✅ Reinitialize components
                  setTimeout(() => {
                     initProductMediaSwiper?.();
                  }, 100);

                  // ✅ Open modal
                  void modal.offsetWidth;
                  modal.classList.add("active");
               } else {
                  modalContent.innerHTML = "<p>Product details not found.</p>";
               }
            })
            .catch((err) => {
               console.error("Quick view error:", err);
               document.querySelector(".quick-view-modal__content").innerHTML =
                  "<p>Error loading product details.</p>";
               Spinner?.hide?.();
            });
      }
   });

   // Close modal on outside click
   document
      .getElementById("quick-view-modal")
      ?.addEventListener("click", (e) => {
         if (e.target === e.currentTarget) {
            e.currentTarget.classList.remove("active");
         }
      });
});

//Dynamic change of tool tip
document.addEventListener("DOMContentLoaded", () => {
   document.querySelectorAll(".product-card__hover-icon").forEach((icon) => {
      const defaultText = icon.getAttribute("data-tooltip");
      const altText = icon.classList.contains("add-to-wishlist") ?
         "Remove from Wishlist" :
         icon.classList.contains("add-to-compare") ?
         "Remove from Compare" :
         defaultText;

      const updateTooltip = () => {
         const isActive = icon.classList.contains("active");
         icon.setAttribute("data-tooltip", isActive ? altText : defaultText);
      };

      // Initial set
      updateTooltip();

      // Optional: observe class changes (e.g., from JS toggling active)
      const observer = new MutationObserver(() => updateTooltip());
      observer.observe(icon, {
         attributes: true,
         attributeFilter: ["class"]
      });
   });
});

//preloader
function preloaderText() {
   const preloader = document.getElementById("ctn-preloader");
   if (preloader) {
      preloader.classList.add("loaded");

      // Optional: fully hide it after animation finishes
      setTimeout(() => {
         preloader.style.display = "none";
      }, 1000); // adjust timing to match your exit animation
   }
}

//Vertical ticker
jQuery.fn.liScroll = function (settings) {
   settings = jQuery.extend({
         travelocity: 0.03,
      },
      settings
   );
   return this.each(function () {
      var $strip = jQuery(this);
      $strip.addClass("newsticker");
      var stripHeight = 1;
      $strip.find("li").each(function (i) {
         stripHeight += jQuery(this, i).outerHeight(true); // thanks to Michael Haszprunar and Fabien Volpi
      });
      var $mask = $strip.wrap("<div class='mask'></div>");
      var $tickercontainer = $strip
         .parent()
         .wrap("<div class='tickercontainer'></div>");
      var containerHeight = $strip.parent().parent().height(); //a.k.a. 'mask' width
      $strip.height(stripHeight);
      var totalTravel = stripHeight;
      var defTiming = totalTravel / settings.travelocity; // thanks to Scott Waye
      function scrollnews(spazio, tempo) {
         $strip.animate({
            top: "-=" + spazio
         }, tempo, "linear", function () {
            $strip.css("top", containerHeight);
            scrollnews(totalTravel, defTiming);
         });
      }
      scrollnews(totalTravel, defTiming);
      $strip.hover(
         function () {
            jQuery(this).stop();
         },
         function () {
            var offset = jQuery(this).offset();
            var residualSpace = offset.top + stripHeight;
            var residualTime = residualSpace / settings.travelocity;
            scrollnews(residualSpace, residualTime);
         }
      );
   });
};

//Sales toast function
function sales_toast() {
   const toastBox = document.querySelector(".sales-toast");
   const toastImg = document.getElementById("toast-img");
   const toastText = document.getElementById("toast-text");

   // Parse comma-separated strings from data attributes
   const names = (toastBox.dataset.names || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

   const cities = (toastBox.dataset.cities || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

   // Interval and timeout from data attributes
   const interval = parseInt(toastBox.dataset.interval, 10) || 10000;
   const timeout = parseInt(toastBox.dataset.timeout, 10) || 5000;

   // Helper: Random selection
   function getRandom(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
   }

   function getRandomName() {
      const name = getRandom(names);
      const city = getRandom(cities);
      return `${name} from ${city}`;
   }

   function showToast() {
      const productsJSON =
         document.getElementById("sales-toast-products")?.textContent || "[]";
      let products = [];

      try {
         products = JSON.parse(productsJSON);
      } catch (e) {
         console.error("Invalid products JSON", e);
         return;
      }

      if (!products.length || !names.length || !cities.length) return;

      const product = getRandom(products);

      toastImg.src = product.image;
      toastText.innerHTML = `<strong>${getRandomName()}</strong> just bought <a href="${
      product.url
    }" class="sales-toast-link">${product.title}</a>`;

      toastBox.classList.remove("hidden");
      toastBox.classList.add("show");

      setTimeout(() => {
         toastBox.classList.remove("show");
         setTimeout(() => toastBox.classList.add("hidden"), timeout);
      }, 4000);
   }

   // Start the cycle
   setTimeout(() => {
      showToast();
      setInterval(showToast, interval);
   }, 3000);
}

//video lazy loading

function ugc_video_lazy_load() {
   const videos = document.querySelectorAll("video[data-autoplay]");

   const observer = new IntersectionObserver(
      (entries, obs) => {
         entries.forEach((entry) => {
            if (entry.isIntersecting) {
               const video = entry.target;

               // Load sources
               video.querySelectorAll("source").forEach((source) => {
                  source.src = source.dataset.src;
               });

               video.load();
               video.play().catch(() => {}); // autoplay may fail silently
               obs.unobserve(video);
            }
         });
      }, {
         threshold: 0.25
      }
   );

   videos.forEach((video) => observer.observe(video));
}

//GDPR Cookies
function initializeGDPRBanner() {
   var gdprAcceptButton = document.getElementById("gdpr-accept");
   var gdprRejectButton = document.getElementById("gdpr-reject");
   var gdprContainerBox = document.getElementById("gdpr-container");

   if (!gdprAcceptButton || !gdprRejectButton || !gdprContainerBox) return;

   function setCookieGdpr(cname, cvalue, exdays) {
      var expires = "";
      if (exdays !== undefined) {
         var d = new Date();
         d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
         expires = "expires=" + d.toUTCString();
      } else {
         expires = "expires=Fri, 31 Dec 2033 23:59:59 GMT";
      }
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
   }

   function getCookieGdpr(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
         var c = ca[i].trim();
         if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
         }
      }
      return "";
   }

   gdprAcceptButton.addEventListener("click", function () {
      setCookieGdpr("gdprConsentAnswer", "yes");
      gdprContainerBox.classList.add("gdpr_container_hide");
   });

   gdprRejectButton.addEventListener("click", function () {
      setCookieGdpr("gdprConsentAnswer", "no");
      gdprContainerBox.classList.add("gdpr_container_hide");
   });

   var gdprconsent = getCookieGdpr("gdprConsentAnswer");
   if (gdprconsent === "") {
      gdprContainerBox.classList.remove("gdpr_container_hide");
   } else {
      gdprContainerBox.classList.add("gdpr_container_hide");
   }
}

//product-info-tabs
function openTabs(evt, tabName) {
   var i, x, tablinks;
   x = document.getElementsByClassName("product_tabs");
   for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
   }
   tablinks = document.getElementsByClassName("tablink");
   for (i = 0; i < x.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
   }
   document.getElementById(tabName).style.display = "block";
   evt.currentTarget.className += " active";
}

//product action popup - add to cart
document.addEventListener('DOMContentLoaded', function () {
   const forms = document.querySelectorAll('.quick-add-to-cart-form');

   forms.forEach(form => {
      form.addEventListener('submit', function (event) {
         event.preventDefault(); // Prevent default form submission

         const variantId = form.querySelector('[name="id"]').value; // Get the variant ID
         const quantity = form.querySelector('[name="quantity"]')?.value || 1; // Get quantity or default to 1
         const submitButton = form.querySelector('.add-to-cart-button');

         // Show loading state
         submitButton.disabled = true;
         submitButton.classList.add('loading');

         // Perform AJAX request to add to cart
         fetch('/cart/add.js', {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
               },
               body: JSON.stringify({
                  id: variantId,
                  quantity: quantity
               })
            })
            .then((res) => {
               if (!res.ok) throw new Error('Add to cart failed');
               return res.json();
            })
            .then((cart) => {
               // Trigger Google Analytics event
               if (typeof ga === 'function' && submitButton) {
                  const productType = submitButton.dataset.productType || 'Unknown';
                  const productTitle = submitButton.dataset.productTitle || 'Unknown';
                  ga('send', 'event', 'Quick Add To Cart', productType, productTitle);
               }

               // Fetch all required sections for CartDrawer
               const sectionsToFetch = [
                  'cart-drawer',
                  'cart-icon-bubble',
                  'cart-icon-bubble-sticky-footer'
               ].join(',');
               return Promise.all([
                  fetch(`/cart?sections=${sectionsToFetch}`).then(res => res.json()),
                  Promise.resolve(cart) // Pass cart data to next step
               ]);
            })
            .then(([sectionData, cart]) => {
               // Prepare parsed state for renderContents
               const parsedState = {
                  id: cart.id,
                  sections: sectionData
               };

               // Update cart drawer using theme's CartDrawer
               const cartDrawer = document.querySelector('cart-drawer');
               if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                  // Remove empty state classes explicitly
                  cartDrawer.classList.remove('is-empty');
                  const drawerInner = cartDrawer.querySelector('.drawer__inner');
                  if (drawerInner) {
                     drawerInner.classList.remove('drawer__inner-empty');
                  } else {
                     //console.warn('Drawer inner element not found');
                  }

                  // Hide any empty cart message
                  const emptyCartMessage = cartDrawer.querySelector('.cart__empty-text, .empty-cart-message');
                  if (emptyCartMessage) {
                     emptyCartMessage.style.display = 'none';
                  }

                  // Call renderContents to update drawer and other sections            
                  cartDrawer.renderContents(parsedState);

                  // Force animation with increased delay and reflow
                  if (typeof cartDrawer.open === 'function') {

                     // Remove classes to reset animation state
                     cartDrawer.classList.remove('animate', 'active');
                     // Force reflow to ensure CSS transition triggers
                     void cartDrawer.offsetWidth; // Trigger reflow
                     // Re-add classes with increased delay
                     setTimeout(() => {
                        cartDrawer.classList.add('animate', 'active');
                     }, 100); // Increased delay to 100ms
                  } else {
                     //console.warn('CartDrawer open method not found');
                  }
               } else {
                  // Fallback: Manual update if CartDrawer is not available
                  //console.warn('CartDrawer element or renderContents method not found. Falling back to manual update.');

                  // Update cart bubble
                  const bubbleHtml = sectionData['cart-icon-bubble'];
                  if (bubbleHtml) {
                     const bubbleParser = new DOMParser();
                     const bubbleDoc = bubbleParser.parseFromString(bubbleHtml, 'text/html');
                     const updatedBubble = bubbleDoc.querySelector('.shopify-section');
                     if (updatedBubble) {
                        const target = document.querySelector('#cart-icon-bubble .shopify-section');
                        if (target) {
                           target.innerHTML = updatedBubble.innerHTML;
                        } else {
                           const fallback = document.getElementById('cart-icon-bubble');
                           if (fallback) fallback.innerHTML = updatedBubble.innerHTML;
                        }

                     }
                  }

                  // Update sticky footer bubble
                  const stickyBubbleHtml = sectionData['cart-icon-bubble-sticky-footer'];
                  if (stickyBubbleHtml) {
                     const stickyParser = new DOMParser();
                     const stickyDoc = stickyParser.parseFromString(stickyBubbleHtml, 'text/html');
                     const updatedStickyBubble = stickyDoc.querySelector('.shopify-section');
                     if (updatedStickyBubble) {
                        const target = document.querySelector('#cart-icon-bubble-sticky-footer .shopify-section');
                        if (target) {
                           target.innerHTML = updatedStickyBubble.innerHTML;
                        } else {
                           const fallback = document.getElementById('cart-icon-bubble-sticky-footer');
                           if (fallback) fallback.innerHTML = updatedStickyBubble.innerHTML;
                        }

                     }
                  }

                  // Update cart drawer
                  const drawerHtml = sectionData['cart-drawer'];
                  if (drawerHtml) {
                     const drawerParser = new DOMParser();
                     const drawerDoc = drawerParser.parseFromString(drawerHtml, 'text/html');

                     // Update cart items
                     const updatedCartItems = drawerDoc.querySelector('#CartDrawer-CartItems');
                     const cartItemsTarget = document.querySelector('#CartDrawer-CartItems');
                     if (updatedCartItems && cartItemsTarget) {
                        cartItemsTarget.innerHTML = updatedCartItems.innerHTML;

                     } else {

                     }

                     // Update subtotals
                     const updatedTotals = drawerDoc.querySelector('.totals');
                     const totalsTarget = document.querySelector('.totals');
                     if (updatedTotals && totalsTarget) {
                        totalsTarget.innerHTML = updatedTotals.innerHTML;
                     }
                  }

                  // Remove empty state classes and open drawer manually
                  if (cartDrawer) {
                     cartDrawer.classList.remove('is-empty');
                     const drawerInner = cartDrawer.querySelector('.drawer__inner');
                     if (drawerInner) {
                        drawerInner.classList.remove('drawer__inner-empty');
                     }
                     if (typeof cartDrawer.open === 'function') {
                        cartDrawer.classList.remove('animate', 'active');
                        void cartDrawer.offsetWidth; // Trigger reflow
                        setTimeout(() => {
                           cartDrawer.classList.add('animate', 'active');
                        }, 100);
                     }
                  }
               }

               // Reinitialize cart drawer
               if (typeof reInitCartDrawer === 'function') {
                  reInitCartDrawer();
               }
            })
            .catch((err) => {
               //console.error('Error:', err);
               alert('Error adding product to cart: ' + err.message);
            })
            .finally(() => {
               submitButton.disabled = false;
               submitButton.classList.remove('loading');
            });
      });
   });
});

// change product card loop image - variant selector
document.addEventListener("DOMContentLoaded", () => {
   // --- Utility: update product image ---
   const updateImage = (productImage, productData, imageMap, variantId, variantTitle) => {
      let newImage = imageMap[variantId];
      if (!newImage) {
         newImage = productData.featured_image;
      }

      if (newImage && productImage) {
         productImage.srcset =
            `${newImage.replace("1500", "375")} 375w, ` +
            `${newImage.replace("1500", "750")} 750w, ` +
            `${newImage.replace("1500", "1100")} 1100w, ` +
            `${newImage} 1500w`;
         productImage.src = newImage;
         productImage.alt = `${productData.title} - ${variantTitle}`;
      }
   };

   // --- Utility: fetch variant image if needed ---
   const fetchVariantImage = (variantId, variantTitle, productData, imageMap, productImage) => {
      fetch(`/products/${productData.handle}.json`)
         .then((response) => response.json())
         .then((data) => {
            const variant = data.product.variants.find((v) => v.id === parseInt(variantId));
            if (variant && variant.featured_image) {
               imageMap[variant.id] = variant.featured_image.src;
               updateImage(productImage, productData, imageMap, variant.id, variant.title);
            } else {
               updateImage(productImage, productData, imageMap, variantId, variantTitle);
            }
         })
         .catch(() => {
            updateImage(productImage, productData, imageMap, variantId, variantTitle);
         });
   };

   // --- Event delegation for variant select (dropdown) ---
   document.addEventListener("change", (event) => {
      if (!event.target.matches(".popup-variant")) return;

      const card = event.target.closest(".product-card");
      if (!card) return;

      const productDataElement = card.querySelector(".product-data");
      if (!productDataElement) return;

      let productData;
      try {
         productData = JSON.parse(productDataElement.textContent);
      } catch {
         return;
      }

      const productImage = card.querySelector(".card__media img");
      if (!productImage) return;

      // Build image map
      const imageMap = {};
      if (Array.isArray(productData?.variants)) {
         productData.variants.forEach((variant, index) => {
            imageMap[variant.id] = productData.media[index]?.src || productData.featured_image;
         });
      }

      const variantId = event.target.value;
      const variantTitle = event.target.selectedOptions[0].textContent;

      fetchVariantImage(variantId, variantTitle, productData, imageMap, productImage);
   });

   // --- Event delegation for variant buttons ---
   document.addEventListener("click", (event) => {
      const button = event.target.closest(".variant-button");
      if (!button) return;

      const card = button.closest(".product-card");
      if (!card) return;

      const productDataElement = card.querySelector(".product-data");
      if (!productDataElement) return;

      let productData;
      try {
         productData = JSON.parse(productDataElement.textContent);
      } catch {
         return;
      }

      const productImage = card.querySelector(".card__media img");
      if (!productImage) return;

      // Build image map
      const imageMap = {};
      if (Array.isArray(productData?.variants)) {
         productData.variants.forEach((variant, index) => {
            imageMap[variant.id] = productData.media[index]?.src || productData.featured_image;
         });
      }

      const variantId = button.dataset.variantId;
      const variantTitle = button.textContent;

      fetchVariantImage(variantId, variantTitle, productData, imageMap, productImage);

      // Update active button state
      card.querySelectorAll(".variant-button").forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");
   });
});


// change product card variant image - color swatch selector - for product card v3
document.addEventListener("DOMContentLoaded", () => {
   // --- Utility: update product image ---
   const updateImage = (productImage, productData, imageMap, variantId, color) => {
      let newImage = imageMap[variantId];
      if (!newImage) {
         newImage = productData.featured_image;
      }

      if (newImage && productImage) {
         productImage.srcset =
            `${newImage.replace("1500", "375")} 375w, ` +
            `${newImage.replace("1500", "750")} 750w, ` +
            `${newImage.replace("1500", "1100")} 1100w, ` +
            `${newImage} 1500w`;
         productImage.src = newImage;
         productImage.alt = `${productData.title} - ${color}`;
      }
   };

   // --- Utility: fetch image from product.json if needed ---
   const fetchVariantImage = (variantId, color, productHandle, productData, imageMap, productImage) => {
      if (!productHandle || productHandle === "unknown") {
         updateImage(productImage, productData, imageMap, variantId, color);
         return;
      }

      fetch(`/products/${productHandle}.json`)
         .then((response) => {
            if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
            return response.json();
         })
         .then((data) => {
            if (!data.product || !data.product.variants) {
               updateImage(productImage, productData, imageMap, variantId, color);
               return;
            }

            const variant = data.product.variants.find((v) => v.id === parseInt(variantId));
            let newImage = null;
            if (variant && variant.featured_image) {
               newImage = variant.featured_image.src;
            } else {
               const media = data.product.media?.find(
                  (m) => m.variant_ids && m.variant_ids.includes(parseInt(variantId))
               );
               newImage = media?.src;
            }

            if (newImage) {
               imageMap[variantId] = newImage;
               updateImage(productImage, productData, imageMap, variantId, color);
            } else {
               updateImage(productImage, productData, imageMap, variantId, color);
            }
         })
         .catch(() => {
            updateImage(productImage, productData, imageMap, variantId, color);
         });
   };

   // --- Event delegation for swatches ---
   document.addEventListener("click", (event) => {
      const swatch = event.target.closest(".color-swatch");
      if (!swatch) return; // not a swatch click

      const card = swatch.closest(".product-card-v3");
      if (!card) return;

      const productDataElement = card.querySelector(".product-data");
      if (!productDataElement) return;

      let productData;
      try {
         productData = JSON.parse(productDataElement.textContent);
      } catch {
         return;
      }

      const productImage = card.querySelector(".card__media img");
      if (!productImage) return;

      const variantId = swatch.dataset.variantId;
      const color = swatch.dataset.color;
      const productHandle = swatch.dataset.productHandle;
      const colorOption = card.querySelector(".color-swatches")?.dataset.colorOption || "unknown";

      // Build initial imageMap for this card
      const imageMap = {};
      if (productData && Array.isArray(productData.variants)) {
         productData.variants.forEach((variant) => {
            const media = productData.media?.find(
               (m) => m.variant_ids && m.variant_ids.includes(variant.id)
            );
            imageMap[variant.id] =
               media?.src ||
               variant.featured_image?.src ||
               swatch.dataset.image ||
               productData.featured_image;
         });
      }

      // Fetch and update image
      fetchVariantImage(variantId, color, productHandle, productData, imageMap, productImage);

      // Update active state
      card.querySelectorAll(".color-swatch").forEach((s) => s.classList.remove("active"));
      swatch.classList.add("active");
   });
});


/*Video lazy load*/
document.addEventListener('lazybeforeunveil', function (e) {
   var video = e.target.tagName === 'VIDEO' ? e.target : e.target.querySelector('video');
   if (video) {
      video.querySelectorAll('source').forEach(function (source) {
         if (source.dataset.src) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
         }
      });
      video.load();
      video.play().catch(function (error) {});
   }
});

/*Footer Collapsible*/
function toggleFooterContent(element) {
   if (window.innerWidth <= 767) {
      const content = element.nextElementSibling;
      element.classList.toggle('active');
      content.classList.toggle('active');
   }
}


// Select all header inline menus
let header_menus = document.querySelectorAll(".header__inline-menu");

// Loop through each header menu
header_menus.forEach((header_menu) => {
   // Select all mega menus and dropdown menus within the current menu
   let header_megamenus = header_menu.querySelectorAll(".mega-menu");
   let header_submenus = header_menu.querySelectorAll(".dropdown-menus");

   // Desktop (hover behavior)
   if (window.innerWidth >= 990) {
      // Loop to open/close mega menus
      header_megamenus.forEach((header_megamenu) => {
         const parentLi = header_megamenu.closest(".header__inline-menu-li");

         if (parentLi) {
            parentLi.addEventListener("mouseenter", () => {
               header_megamenu.classList.remove("inactive");
               header_megamenu.setAttribute("open", true);
               header_megamenu.classList.add("active");
            });

            parentLi.addEventListener("mouseleave", () => {
               header_megamenu.removeAttribute("open");
               header_megamenu.classList.remove("active");
               header_megamenu.classList.add("inactive");
            });
         }
      });

      // Loop to open/close dropdown submenus
      header_submenus.forEach((header_submenu) => {
         const parentLi = header_submenu.closest(".header__inline-menu-li");

         if (parentLi) {
            parentLi.addEventListener("mouseenter", () => {
               header_submenu.classList.remove("inactive");
               header_submenu.setAttribute("open", true);
               header_submenu.classList.add("active");
            });

            parentLi.addEventListener("mouseleave", () => {
               header_submenu.removeAttribute("open");
               header_submenu.classList.remove("active");
               header_submenu.classList.add("inactive");
            });
         }
      });
   }

   // Mobile (click-to-toggle collapsible behavior)
   if (window.innerWidth < 990) {
      header_megamenus.forEach((header_megamenu) => {
         const parentLi = header_megamenu.closest(".header__inline-menu-li");

         // ✅ trigger is .my_mega_menu inside the li
         const trigger = parentLi.querySelector(".header__menu-item");

         if (trigger) {
            trigger.addEventListener("click", function (e) {
               e.preventDefault();

               // If already active → close
               if (header_megamenu.classList.contains("active")) {
                  header_megamenu.classList.remove("active");
                  header_megamenu.removeAttribute("open");
               } else {
                  // Close others (accordion effect)
                  header_menu.querySelectorAll(".mega-menu.active, .dropdown-menus.active").forEach((openMenu) => {
                     openMenu.classList.remove("active");
                     openMenu.removeAttribute("open");
                  });

                  // Open this one
                  header_megamenu.classList.add("active");
                  header_megamenu.setAttribute("open", true);
               }
            });
         }
      });

      header_submenus.forEach((header_submenu) => {
         const parentLi = header_submenu.closest(".header__inline-menu-li");

         // ✅ trigger is .my_mega_menu inside dropdown
         const trigger = parentLi.querySelector(".header__menu-item");

         if (trigger) {
            trigger.addEventListener("click", function (e) {
               e.preventDefault();

               if (header_submenu.classList.contains("active")) {
                  header_submenu.classList.remove("active");
                  header_submenu.removeAttribute("open");
               } else {
                  header_menu.querySelectorAll(".mega-menu.active, .dropdown-menus.active").forEach((openMenu) => {
                     openMenu.classList.remove("active");
                     openMenu.removeAttribute("open");
                  });

                  header_submenu.classList.add("active");
                  header_submenu.setAttribute("open", true);
               }
            });
         }
      });
   }

});



let cursor = document.querySelector(".cursor-gsap");
let cursor2 = document.querySelector(".cursor-gsap2");
let cursorScale = document.querySelectorAll(".cursor-scale");
let mouseX = 0;
let mouseY = 0;

gsap.to({}, 0.016, {
  repeat: -1,
  onRepeat: function () {
    gsap.set(cursor, {
      css: {
        left: mouseX,
        top: mouseY
      }
    });
    gsap.set(cursor2, {
      css: {
        left: mouseX,
        top: mouseY
      }
    });
  }
});

window.addEventListener("mousemove", (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;
});

cursorScale.forEach((link) => {
  link.addEventListener("mousemove", () => {
    cursor.classList.add("grow");
    if (link.classList.contains("small")) {
      cursor.classList.remove("grow");
      cursor.classList.add("grow-small");
    }
  });

  link.addEventListener("mouseleave", () => {
    cursor.classList.remove("grow");
    cursor.classList.remove("grow-small");
  });
});


/* Card Product Image Slider */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-slider]').forEach(slider => {
    const track = slider.querySelector('.product-card-slider__track');
    const slides = slider.querySelectorAll('.product-card-slider__slide');
    const prev = slider.querySelector('.prev');
    const next = slider.querySelector('.next');

    if (!track || slides.length <= 1) return;

    let index = 0;

    const update = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    next.addEventListener('click', e => {
      e.preventDefault();
      index = (index + 1) % slides.length;
      update();
    });

    prev.addEventListener('click', e => {
      e.preventDefault();
      index = (index - 1 + slides.length) % slides.length;
      update();
    });
  });
});


(function () {
  const WISHLIST_KEY = "shopify-wishlist";

  function updateWishlistBubble() {
    const bubble = document.getElementById("wishlist-count");
    if (!bubble) return;

    const list = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    const count = list.length;

    if (count > 0) {
      bubble.textContent = count;
      bubble.hidden = false;
    } else {
      bubble.hidden = true;
    }
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", updateWishlistBubble);

  // When your existing code updates wishlist and dispatches event
  window.addEventListener("wishlist:updated", updateWishlistBubble);

  // Fallback: detect any localStorage change from same tab
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function (key, value) {
    originalSetItem.apply(this, arguments);
    if (key === WISHLIST_KEY) {
      updateWishlistBubble();
    }
  };

  // Cross-tab support
  window.addEventListener("storage", function (e) {
    if (e.key === WISHLIST_KEY) updateWishlistBubble();
  });
})();



